<template>
  <div class="relative w-fit">
    <button
      class="rounded max-w-max flex justify-center items-center text-center cursor-pointer min-h-13 px-3 label-lg border border-black hover:bg-grey hover:text-white"
      :aria-expanded="isMenuOpen"
      aria-controls="language-menu"
      aria-haspopup="menu"
      :aria-label="`${isMenuOpen ? 'Close' : 'Open'} language selection`"
      @click="handleClick"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        class="mr-2"
        aria-hidden="true"
      >
        <g clip-path="url(#clip0_4052_339)">
          <path
            d="M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM11.5 19.93C7.55 19.44 4.5 16.08 4.5 12C4.5 11.38 4.58 10.79 4.71 10.21L9.5 15V16C9.5 17.1 10.4 18 11.5 18V19.93ZM18.4 17.39C18.14 16.58 17.4 16 16.5 16H15.5V13C15.5 12.45 15.05 12 14.5 12H8.5V10H10.5C11.05 10 11.5 9.55 11.5 9V7H13.5C14.6 7 15.5 6.1 15.5 5V4.59C18.43 5.78 20.5 8.65 20.5 12C20.5 14.08 19.7 15.97 18.4 17.39Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_4052_339">
            <rect width="24" height="24" fill="none" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
      {{ props.data.button_text
      }}<svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        aria-hidden="true"
        :class="`${isMenuOpen ? 'rotate-180 ' : ''}transition-transform duration-300 ease-in-out`"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5003 15.5996L6.71456 9.81456L8.12869 8.40026L12.5003 12.7714L16.872 8.40026L18.2861 9.81457L12.5003 15.5996Z"
          fill="currentColor"
        />
      </svg>
    </button>
    <div
      v-if="isMenuOpen"
      id="language-menu"
      class="rounded border border-black absolute top-full right-0 bg-stone flex flex-col p-4 items-end gap-2"
      role="menu"
    >
      <component
        :is="lang.active ? 'p' : 'a'"
        v-for="lang in props.languages"
        :key="lang.language_code"
        :href="!lang.active ? lang.url : undefined"
        :class="['button button-primary button-small', { disabled: lang.active }]"
        role="menuitem"
        :aria-current="lang.active ? 'true' : undefined"
        :tabindex="lang.active ? undefined : 0"
      >
        {{ lang.native_name }} ({{ lang.language_code }})
      </component>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
  languages: Array<{
    language_code: string
    native_name: string
    url: string
    active: string
  }>
  data: {
    button_text: string
  }
}>()

const isMenuOpen = ref(false)

const handleClick = () => {
  toggleMenu()
}

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}
</script>
<style>
.disabled {
  @apply cursor-default pointer-events-none bg-light-grey;
}
</style>
